module.exports = __webpack_public_path__ + "img/banner.32358a2c.png";